import { reportSystemError } from './systemErrors';

export const logError = (error, context) => {
  reportSystemError(error, { code: 'RENDER_ERROR' });
  // Basic structured error log
  // eslint-disable-next-line no-console
  console.error('[Error]', { context, message: error?.message, stack: error?.stack });
};

export const logInfo = (message, context) => {
  // eslint-disable-next-line no-console
  console.log('[Info]', { context, message });
};

export default {
  logError,
  logInfo,
};
